import { fetchWrapRPC } from '../services/api';
import {
  AggregateService_ListAggregates,
  AggregateService_ListBaselineAggregates,
  type ListAggregatesRequest,
  type ListAggregatesResponse,
  type ListBaselineAggregatesRequest,
  type ListBaselineAggregatesResponse,
} from './gen/ai/h2o/mlops/monitoring/v2/aggregate_service_pb';
import {
  type GenerateAggregatorConfigRequest,
  type GenerateAggregatorConfigResponse,
  MonitoringConfigService_GenerateAggregatorConfig,
} from './gen/ai/h2o/mlops/monitoring/v2/monitoring_config_service_pb';

const PATH_PREFIX = '/monitoring';

export const generateAggregatorConfig = (
  mlopsApiUrl: string,
  request: GenerateAggregatorConfigRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<GenerateAggregatorConfigResponse> => {
  return fetchWrapRPC(MonitoringConfigService_GenerateAggregatorConfig, {
    basePath: `${mlopsApiUrl}${PATH_PREFIX}`,
  })(request, requestInit);
};

export const listAggregates = (
  mlopsApiUrl: string,
  request: ListAggregatesRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<ListAggregatesResponse> => {
  return fetchWrapRPC(AggregateService_ListAggregates, {
    basePath: `${mlopsApiUrl}${PATH_PREFIX}`,
  })(request, requestInit);
};

export const listBaselineAggregates = (
  mlopsApiUrl: string,
  request: ListBaselineAggregatesRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<ListBaselineAggregatesResponse> => {
  return fetchWrapRPC(AggregateService_ListBaselineAggregates, {
    basePath: `${mlopsApiUrl}${PATH_PREFIX}`,
  })(request, requestInit);
};
